import classNames from 'classnames';
import React, { ComponentProps, PropsWithChildren, Ref } from 'react';

import { useUIMode } from '../../contexts/UIModeContext';
import { useUIStyle } from '../../contexts/UIStyleContext';
import { ElementTypes } from '../../util/types';

/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['light', 'dark', 'default', 'highlight', 'medium', 'small', 'primary', 'secondary', 'tertiary', 'userConfirmation'] }] */
import styles from './ActionButton.module.css';
export type ActionButtonStyle = 'primary' | 'secondary' | 'tertiary' | 'userConfirmation';

interface OwnProps<E extends ElementTypes> {
  element?: E;
  buttonStyle: ActionButtonStyle;
  size?: 'medium' | 'small';
  buttonRef?: Ref<HTMLElement>;
  overrideColor?: string;
}

type Props<E extends ElementTypes> = PropsWithChildren<
  OwnProps<E> & Omit<ComponentProps<E>, keyof OwnProps<E>>
>;

export default function ActionButton<E extends ElementTypes>({
  element,
  buttonStyle,
  className,
  children,
  size,
  buttonRef,
  overrideColor,
  style,
  ...props
}: Props<E>) {
  const Element = element ?? 'button';
  const uiStyle = useUIStyle();
  const uiMode = useUIMode();

  return (
    <Element
      className={classNames(
        styles.Button,
        styles[buttonStyle],
        styles[uiStyle],
        styles[uiMode],
        styles[size ?? 'medium'],
        className,
      )}
      style={{
        ...style,
        '--color-override': overrideColor,
      }}
      {...props}
      ref={buttonRef as any}
    >
      {children}
    </Element>
  );
}
